import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IContracts = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="23"
            viewBox="0 0 18 23"
            fill="none"
          >
            <path d="M3 9H9" stroke={props.color??"#37474F"} strokeWidth="1.5" />
            <path d="M3 5H15" stroke={props.color??"#37474F"} strokeWidth="1.5" />
            <path
              d="M10.856 12.5918L13.034 13.7074"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <path
              d="M8.19971 16.6382L11.5996 10.0508L13.884 11.2726L10.3778 17.9131L8.19971 18.6038V16.6382Z"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <rect
              x="1"
              y="1"
              width="16"
              height="21"
              stroke={props.color??"#37474F"}
              strokeWidth="2"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IContracts;
